export const appConstants = {
    fileExtension: {
        pdf: 'pdf'
    },

    textFilterCategory: {
        category: 1,
        code: 2,
        alternativeCode: 3,
        description: 4,
        longDescription: 5,
        brand: 7,
        model: 8,
        productType: 9,
		serie: 10
    },

    sortingCategories: {
        description: 1,
        brand: 2,
		serie: 3,
        productType: 4
    },
    sortNames: {
        description: 'De la A a la Z',
        brand: 'Por Marca',
		serie: 'Por Serie',
        productType: 'Por Tipo de Producto'
    },
    sortingOrder: {
        ascending: 'asc',
        descending: 'desc'
    }
}